export default __webpack_public_path__ + "static/logo-transparent-d4e33b73d382ba1eaf3ceaad7413b760.png";